export default {
  SKIPPED: 'skipped',
  ANSWERED: 'answered',
  DRAFT: 'draft',
  UNANSWERED: undefined,
};
